import { render } from "./SelectWithIcon.vue?vue&type=template&id=0ab2c9e9&scoped=true"
import script from "./SelectWithIcon.vue?vue&type=script&lang=js"
export * from "./SelectWithIcon.vue?vue&type=script&lang=js"

import "./SelectWithIcon.vue?vue&type=style&index=0&id=0ab2c9e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab2c9e9"]])

export default __exports__